// extracted by mini-css-extract-plugin
export default {"root":"ewnK8j","clickable":"jUUN_Z"};